import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './TopicList.css';
import { AuthContext } from '../contexts/AuthContext';
import '../styles/animations.css';

const generateUrl = (name) => {
  if (!name) {
    console.error('Name is undefined or null:', name);
    return '';
  }
  return name.toLowerCase().replace(/ /g, '-');
};

const CATEGORIES = [
  'Society & Governance',
  'Science & Technology',
  'Health & Wellness',
  'Economy & Finance',
  'Philosophy & Ethics',
  'Environment',
  'Warfare & Conflict'
];

const TopicList = () => {
  const [topics, setTopics] = useState([]);
  const [filteredTopics, setFilteredTopics] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const API_URL = process.env.REACT_APP_API_URL;
        const response = await axios.get(`${API_URL}/api/topics`);
        setTopics(response.data);
        setFilteredTopics(response.data);
      } catch (error) {
        console.error('Error fetching topics:', error);
      }
    };

    fetchTopics();
  }, []);

  useEffect(() => {
    if (selectedCategories.length === 0) {
      setFilteredTopics(topics);
    } else {
      const filtered = topics.filter(topic =>
        selectedCategories.includes(topic.category)
      );
      setFilteredTopics(filtered);
    }
  }, [selectedCategories, topics]);

  const handleCategoryClick = (category) => {
    setSelectedCategories(prev => {
      if (prev.includes(category)) {
        return prev.filter(c => c !== category);
      } else {
        return [...prev, category];
      }
    });
  };

  return (
    <div className="container">
      <Helmet>
        <title>Topics - The Other Lens</title>
        <meta name="description" content="Explore a variety of topics with balanced perspectives on major political and social issues." />
        <meta name="keywords" content="topics, balanced perspectives, political issues, social issues, curated content" />
        <link rel="canonical" href="https://www.theotherlensmedia.com/topics" />
      </Helmet>
      <div className="tagline-container">
        <div className="hero-layout">
          <div className="lens-image-container">
            <img src="https://images.unsplash.com/photo-1582994254571-52c62d96ebab?w=800&auto=format&fit=crop&q=80" alt="Camera lens" className="lens-image" />
            <div className="lens-text-overlay">
              <span className="lens-title-top">The Other</span>
              <span className="lens-title-bottom">Lens</span>
            </div>
          </div>
          <div className="slogans-side">
            <p className="slogan-line">Go beyond the headlines.</p>
            <p className="slogan-line">Explore every perspective.</p>
            <div className="slogan-divider"></div>
            <p className="slogan-accent">Big questions. Real experts. No agenda.</p>
          </div>
        </div>
      </div>

      <div className="category-filter">
        {CATEGORIES.map((category) => (
          <button
            key={category}
            className={`category-button ${selectedCategories.includes(category) ? 'active' : ''}`}
            onClick={() => handleCategoryClick(category)}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="topics-container position-relative">
        <div className="topic-grid">
          {filteredTopics.map((topic) => (
            <div key={topic._id} className="topic-item">
              <h5>
                <Link to={`/topics/${generateUrl(topic.name)}`} className="topic-link">
                  {topic.name}
                </Link>
              </h5>
              <hr />
              <ul className="list-unstyled">
                {Array.isArray(topic.subtopics) && topic.subtopics.map(subtopic => (
                  <li key={subtopic._id}>
                    <Link
                      to={`/subtopics/${subtopic._id}`}
                      className="subtopic-link"
                    >
                      {subtopic.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <br></br>
      <div className="missing-something-container">
        <p className="missing-something">
          Suggest a new topic or provide feedback <a href="https://docs.google.com/forms/d/e/1FAIpQLSe4BzmVXXkQu0rOLwgr0m320nGDMot4ZK673H-VMZUFmT2Pog/viewform?usp=publish-editor" target="_blank" rel="noopener noreferrer">here</a>
        </p>
      </div>
    </div>
  );
};

export default TopicList;
